import {
  branch,
  compose,
  lifecycle,
  renderNothing,
  withHandlers,
} from 'recompose';
import { connect } from 'react-redux';
import WithShop from '../../hoc/WithShop';
import WithShopCurrency from '../../hoc/WithShopCurrency';
import { getCountryCodeByCountryAndCurrency } from '../../utils/intl';
import WithInstantExperiences from '../../hoc/WithInstantExperiences';
import WithApplePayQuery from '../../hoc/WithApplePayQuery';
import ContactInformation from '../../components/ContactInformation';
import { touchField, updateField } from '../actions';


export default compose(
  WithApplePayQuery,
  WithInstantExperiences,
  WithShop,
  WithShopCurrency,
  branch(
    props => props.withApplePay,
    renderNothing
  ),
  connect(
    (state, ownProps) => ({
      fields: state.reservation.get('fields').toJS(),
      countryCode: getCountryCodeByCountryAndCurrency(ownProps.shop),
    }),
    { touchField, updateField }
  ),
  withHandlers({
    updateField: props => field => (e) => {
      const valueMap = {
        checkbox: event => event.target.checked,
        tel: value => value,
        default: event => event.target.value,
      };

      const valueFn = valueMap[field.type] || valueMap.default;
      const value = valueFn(e);

      props.updateField(field.id, value, props.countryCode, props.shop);
      props.touchField(field.id, props.countryCode, props.shop);
    },
    touchField: props => field => () => props.touchField(field.id, props.countryCode, props.shop),
    updateFieldValue: props => (fieldId, value) => {
      props.updateField(fieldId, value, props.countryCode, props.shop);
      props.touchField(fieldId, props.countryCode, props.shop);
    },
  }),
  lifecycle({
    componentDidMount() {
      const isDeprecatedIgIx = this.props.instantExperiences && !this.props.instantExperiencesOwner;
      if (isDeprecatedIgIx && window.FBExtensions) {
        window.FBExtensions.requestFormFields(
          ({ fields = {} } = {}) => {
            Object.keys(fields).forEach(key => this.props.updateFieldValue(key, fields[key].value));
          },
          () => null,
          {
            fields: [
              { id: 'firstName', label: 'First name', autocomplete: 'given-name' },
              { id: 'lastName', label: 'Last name', autocomplete: 'family-name' },
              { id: 'phone', label: 'Phone number', autocomplete: 'tel-national' },
              { id: 'email', label: 'Email address', autocomplete: 'email' },
            ],
            business_name: 'Squire Technologies',
            terms_url: 'https://getsquire.com/terms-of-service.html',
          }
        );
      }
    },
  })
)(ContactInformation);



// WEBPACK FOOTER //
// ./src/app/reservation/containers/ContactInformation.js